import React from 'react'

import resume from "../../assets/resume/Piyush_Talele_Resume.pdf"

const ProfileLinks = () => {
    return (
        <div className="lnks">
            <a href={resume} target='_blank' className="lnk">
                <span className="text">Download CV</span>
            </a>
            <a href="/contactme" className="lnk discover">
                <span className="text">Contact Me</span>
            </a>
        </div>
    );
}

export default ProfileLinks;